/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import DatosCamara_Generales from './DatosCamara_Generales';
import DatosCamara_Territorios from './DatosCamara_Territorios';
import { usePage } from '../../contexts/pageContext';
import TablaVotosPartidos2023 from './TablaVotosPartidos2023';
import { useViewContext } from '../../contexts/viewContext';
import { level } from '../../resources/constantes.json';

const DatosCamara = ({ tVisible, data, color, header }) => {
  const t = useTranslate();
  const pageState = usePage();
  const { data: dataState } = pageState;
  const circuscripcion = dataState?.camaras?.[0]?.cir;
  const viewContext = useViewContext();
  const showTerritorios = viewContext.scope.l < level.zona;

  return (
    <div
      style={{
        borderBottom: '0px solid',
        borderColor: color,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DatosCamara_Generales data={data} title={t('informacionGeneral')} />

      {circuscripcion && Number(circuscripcion) <= 1 ? (
        <>
          <TablaVotosPartidos2023 camara={data} />
          {tVisible && showTerritorios && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {header}
              <DatosCamara_Territorios data={data} title={t('territorios')} />
            </div>
          )}
        </>
      ) : (
        <>
          {tVisible && showTerritorios && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {header}
              <DatosCamara_Territorios data={data} title={t('territorios')} />
            </div>
          )}

          <TablaVotosPartidos2023 camara={data} />
        </>
      )}
    </div>
  );
};

export default DatosCamara;
